import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { initHubspot, openHubspotWidget } from 'utils/initHubspot';
import '../../NSNavbar.scss';

const HubspotChatWidget: React.FC = () => {
    useEffect(() => {
        initHubspot();
    }, []);

    return (
        <FontAwesomeIcon
            data-hubspot-chat-toggle
            icon={faCircleQuestion}
            className="NSNavbar__right__icon-list__icon cursor--pointer"
            aria-label="support-chat"
            onClick={openHubspotWidget}
        />
    );
};

export default HubspotChatWidget;
